@if (taxon(); as tax) {
  <div class="npdc-title">
    <h1>{{ title() }}</h1>
    <div class="npdc-title__actions">
      <button mat-icon-button [matMenuTriggerFor]="optionsMenu" matTooltip="More actions">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </div>

  <p>
    <a routerLink="/plankton/occurrence" [queryParams]="{ scientificName: tax.scientificName }">
      Show {{ tax.occurrenceCount }} related
      @if (tax.occurrenceCount === 1) {
        occurrence
      } @else {
        occurrences
      }
    </a>
  </p>

  <app-plankton-propertylist [data]="tax"></app-plankton-propertylist>
  <mat-menu #optionsMenu>
    @if (tax.occurrenceCount) {
      <button
        mat-menu-item
        [routerLink]="['/plankton', 'occurrence']"
        [queryParams]="{ scientificName: tax.scientificName }"
      >
        <mat-icon>list</mat-icon> Show {{ tax.occurrenceCount }}
        @if (tax.occurrenceCount === 1) {
          occurrence
        } @else {
          occurrences
        }
      </button>
    }
    @if (tax.scientificNameID) {
      <a mat-menu-item href="{{ tax.scientificNameID | wormsURL }}" target="_blank">
        <mat-icon>open_in_new</mat-icon> Show in WoRMS
      </a>
    }
  </mat-menu>
}
